import script from "./GameView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameView.vue?vue&type=script&setup=true&lang=ts"

import "./GameView.vue?vue&type=style&index=0&id=57ed9956&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ed9956"]])

export default __exports__